enum NotificationStatus {
    granted = 'granted',
    notDetermined = 'notDetermined',
    denied = 'denied'
}

export default NotificationStatus;
